import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index'
import Button from "@material-ui/core/Button";
import Pagination from 'rc-pagination';

const styles = theme => ({
    pageButton: {
        minWidth: 0,
        marginRight: 4,
    }
});

const MaterialPagination = ({classes, disabled, ...props}) => (
    <Pagination
        {...props}
        itemRender={(page, type, el) => {
            let text;
            switch (type) {
                case 'prev':
                    text = '<';
                    break;
                case 'next':
                    text = '>';
                    break;
                case 'page':
                default:
                    text = page;
            }

            return <Button
                disabled={disabled}
                className={classes.pageButton}
                color={page === props.current ? 'primary' : 'default'}
                variant={type === 'page' && page === props.current ? 'contained' : 'outlined'}
                mini
            >
                {text}
            </Button>

        }}
        showTitle={false}
        style={{
            listStyle: 'none',
            padding: 0,
            display: 'flex',
            margin: 8,
            justifyContent: 'center',
        }}
    />
);

MaterialPagination.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(MaterialPagination);


// WEBPACK FOOTER //
// ./src/components/Pagination.js